import {Title} from '@angular/platform-browser';
import {SettingsService} from './../../settings/settings.service';
import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-deep-dive-new',
    templateUrl: './deep-dive-new.component.html',
    styleUrls: ['./deep-dive-new.component.scss'],
    standalone: false
})
export class DeepDiveNewComponent implements OnInit {
	changeLayoutDeepDive = 3;

	constructor(
		private settingsService: SettingsService,
		private titleService: Title
	) {
		this.titleService.setTitle('Deep Dive');
	}

	ngOnInit() {
		this.SettingsGroupByName();
	}
	SettingsGroupByName() {
		try {
			this.settingsService.WebMulSettings('ChangeLayoutForecastDeepDive', { showLoadingIndicator: true }).subscribe(
				(result) => {
					if (result != null && result.length > 0 && result[0].value != null) {
						this.changeLayoutDeepDive = result[0].value;
					} else {
						this.loadIfNotFound();
					}
				},
				(error) => {
					this.loadIfNotFound();
				}
			);
		} catch (error) {
			this.loadIfNotFound();
		}
	}

	loadIfNotFound() {
		this.changeLayoutDeepDive = this.changeLayoutDeepDive ? 0 : this.changeLayoutDeepDive;
		this.changeLayoutDeepDive = this.changeLayoutDeepDive == 0 || this.changeLayoutDeepDive == 1 ? this.changeLayoutDeepDive : 0;
	}
}
